export default "__VITE_ASSET__DgCqYgsW__"